import { PrivacyCenterDto } from "../../../../common/service/server/dto/PrivacyCenterDto";
import { NetworkRequestState } from "../../../../common/models";
import { usePrimaryOrganizationId } from "../../../hooks";
import { useIntegrations, usePrivacyCenter } from "../../../hooks/usePrivacyCenter";
import { PrivacyCenterIntegrationsDto } from "../../../../common/service/server/dto/PrivacyCenterIntegrationsDto";

interface UseIntegrationsSettings {
  settings: PrivacyCenterIntegrationsDto;
  privacyCenter: PrivacyCenterDto;
  privacyCenterRequest: NetworkRequestState;
  integrationsRequest: NetworkRequestState;

  getLatestData: () => void;
}

export const useIntegrationsSettings = (): UseIntegrationsSettings => {
  const organizationId = usePrimaryOrganizationId();

  const [privacyCenter, privacyCenterRequest, _fetch] = usePrivacyCenter(organizationId);

  const [integrations, integrationsRequest, getLatestData] = useIntegrations(
    organizationId,
    privacyCenter?.id,
  );

  return {
    settings: integrations,
    privacyCenter,
    privacyCenterRequest,
    integrationsRequest,
    getLatestData,
  };
};
